// eslint-disable-next-line import/prefer-default-export
export const CONTEXT_PATH = '/dagligbank-lokalbank-web';
